import METADATA from "./LocalConfigurationEntity.metadata.js";
import { BaseEntity } from "clavis-nxt-components-custdevtm";

class LocalConfigurationEntity extends BaseEntity {
  constructor(
    id,
    configuration,
    confValue,
    createdBy,
    createdTs,
    modifiedBy,
    modifiedTs
  ) {
    super();
    this.id = id;
    this.configuration = configuration;
    this.confValue = confValue;
    this.createdBy = createdBy;
    this.createdTs = createdTs;
    this.modifiedBy = modifiedBy;
    this.modifiedTs = modifiedTs;
  }
}

METADATA.connect(LocalConfigurationEntity);

export { LocalConfigurationEntity };
